import type { FaireProductEntity } from "../../entity_types/product";

export const p_nn6m4v8dbb: FaireProductEntity = {
  token: "p_nn6m4v8dbb",
  type: "product",
  name: "red bow wreath mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/f20e263f355c93c2634d5356e2fa4479b36f2cd59602c2219f27737969ea7266.jpeg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty (and easy!) presentation. \n\n\nDetails:\n\n- single card + envelope \n- blank inside\n- 2.5" x 3.5"\n- Printed on 120lb superfine paper\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:11.583Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
